
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import API from './api'
import Toast from './components/toast/index.js'
import cookie from 'js-cookie'
import 'vant/lib/icon/local.css'
import 'vant/lib/index.css'

import { Popup, Dialog, Icon, Collapse, CollapseItem, Cell, CellGroup, Button, Picker, Calendar, Checkbox, CheckboxGroup, Search, IndexAnchor, IndexBar, Divider } from 'vant'
Vue.use(Popup)
Vue.use(Dialog)
Vue.use(Icon)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Button)
Vue.use(Picker)
Vue.use(Calendar)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Search)
Vue.use(IndexAnchor)
Vue.use(IndexBar)
Vue.use(Divider)


Vue.prototype.Dialog = Dialog
Vue.prototype.Cookie = cookie
Vue.prototype.API = API
Vue.prototype.$toast = Toast
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
